var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cardList-wrapper"
  }, [_c("a-row", {
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      xs: 12,
      md: 12,
      sm: 12,
      lg: 8
    }
  }, [_c("div", {
    staticClass: "card-item card-item-one",
    on: {
      click: function ($event) {
        return _vm.sendTitle("今日保费", "sale");
      }
    }
  }, [_c("div", {
    staticClass: "card-title"
  }, [_c("a-space", {
    attrs: {
      size: 8
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "sale",
      size: 20
    }
  }), _vm._v(" " + _vm._s(_vm.$t("今日保费")) + " ")], 1)], 1), _c("div", {
    staticClass: "all-count"
  }, [_vm._v(" ¥ "), _c("count-to", {
    attrs: {
      startVal: 0,
      endVal: 12367,
      duration: 2200
    }
  }), _c("span", {
    staticClass: "suffix"
  }, [_vm._v(_vm._s(_vm.$t("万")))])], 1)])]), _c("a-col", {
    attrs: {
      xs: 12,
      md: 12,
      sm: 12,
      lg: 8
    }
  }, [_c("div", {
    staticClass: "card-item card-item-two",
    on: {
      click: function ($event) {
        return _vm.sendTitle("今日保单", "visit");
      }
    }
  }, [_c("div", {
    staticClass: "card-title"
  }, [_c("a-space", {
    attrs: {
      size: 8
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "visit",
      size: 20
    }
  }), _vm._v(" " + _vm._s(_vm.$t("今日保单")) + " ")], 1)], 1), _c("div", {
    staticClass: "all-count"
  }, [_c("count-to", {
    attrs: {
      startVal: 0,
      endVal: 3750,
      duration: 2200
    }
  }), _c("span", {
    staticClass: "suffix"
  }, [_vm._v(_vm._s(_vm.$t("万次")))])], 1)])]), _c("a-col", {
    attrs: {
      xs: 12,
      md: 12,
      sm: 12,
      lg: 8
    }
  }, [_c("div", {
    staticClass: "card-item card-item-three",
    on: {
      click: function ($event) {
        return _vm.sendTitle("总保单", "shopCard");
      }
    }
  }, [_c("div", {
    staticClass: "card-title"
  }, [_c("a-space", {
    attrs: {
      size: 8
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "shopCard",
      size: 20
    }
  }), _vm._v(" " + _vm._s(_vm.$t("总保单")) + " ")], 1)], 1), _c("div", {
    staticClass: "all-count"
  }, [_c("count-to", {
    attrs: {
      startVal: 0,
      endVal: 129795,
      duration: 2200
    }
  }), _c("span", {
    staticClass: "suffix"
  }, [_vm._v(_vm._s(_vm.$t("个")))])], 1)])]), _c("a-col", {
    attrs: {
      xs: 12,
      md: 12,
      sm: 12,
      lg: 8
    }
  }, [_c("div", {
    staticClass: "card-item card-item-four",
    on: {
      click: function ($event) {
        return _vm.sendTitle("总保费", "pay");
      }
    }
  }, [_c("div", {
    staticClass: "card-title"
  }, [_c("a-space", {
    attrs: {
      size: 8
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "pay",
      size: 20
    }
  }), _vm._v(" " + _vm._s(_vm.$t("总保费")) + " ")], 1)], 1), _c("div", {
    staticClass: "all-count"
  }, [_vm._v(" ¥ "), _c("count-to", {
    attrs: {
      startVal: 0,
      endVal: 13996,
      duration: 2200
    }
  }), _c("span", {
    staticClass: "suffix"
  }, [_vm._v(_vm._s(_vm.$t("万")))])], 1)])]), _c("a-col", {
    attrs: {
      xs: 12,
      md: 12,
      sm: 12,
      lg: 8
    }
  }, [_c("div", {
    staticClass: "card-item card-item-five",
    on: {
      click: function ($event) {
        return _vm.sendTitle("用户", "pay");
      }
    }
  }, [_c("div", {
    staticClass: "card-title"
  }, [_c("a-space", {
    attrs: {
      size: 8
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "pay",
      size: 20
    }
  }), _vm._v(" " + _vm._s(_vm.$t("用户")) + " ")], 1)], 1), _c("div", {
    staticClass: "all-count"
  }, [_c("count-to", {
    attrs: {
      startVal: 0,
      endVal: 13996,
      duration: 2200
    }
  }), _c("span", {
    staticClass: "suffix"
  }, [_vm._v(_vm._s(_vm.$t("万次")))])], 1)])]), _c("a-col", {
    attrs: {
      xs: 12,
      md: 12,
      sm: 12,
      lg: 8
    }
  }, [_c("div", {
    staticClass: "card-item card-item-six",
    on: {
      click: function ($event) {
        return _vm.sendTitle("用户", "pay");
      }
    }
  }, [_c("div", {
    staticClass: "card-title"
  }, [_c("a-space", {
    attrs: {
      size: 8
    }
  }, [_c("svg-icon", {
    attrs: {
      icon: "pay",
      size: 20
    }
  }), _vm._v(" " + _vm._s(_vm.$t("用户")) + " ")], 1)], 1), _c("div", {
    staticClass: "all-count"
  }, [_c("count-to", {
    attrs: {
      startVal: 0,
      endVal: 13996,
      duration: 2200
    }
  }), _c("span", {
    staticClass: "suffix"
  }, [_vm._v(_vm._s(_vm.$t("万次")))])], 1)])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };